import { Controller } from "@hotwired/stimulus"

export function createMountBridgeController(
  mountFnName: string,
  unmountFnName: string,
) {
  return class extends Controller {
    _readyHandler: (() => void) | null = null

    connect() {
      const win = window as unknown as Record<
        string,
        ((el: Element) => void) | undefined
      >
      if (win[mountFnName]) {
        win[mountFnName]!(this.element)
      } else {
        this._readyHandler = () => win[mountFnName]?.(this.element)
        window.addEventListener("warehouse:ready", this._readyHandler, {
          once: true,
        })
      }
    }

    disconnect() {
      if (this._readyHandler) {
        window.removeEventListener("warehouse:ready", this._readyHandler)
        this._readyHandler = null
      }
      const win = window as unknown as Record<
        string,
        ((el: Element) => void) | undefined
      >
      win[unmountFnName]?.(this.element)
    }
  }
}
